export default __webpack_public_path__ + "static/media/sm.89e3254d.gif";